import type { FunctionComponent, PropsWithChildren } from 'react';

import { useFeatureFlag } from '@trello/feature-flag-client';

interface JwmAdWrapperProps {
  segmentName: string;
}

export const JwmAdWrapper: FunctionComponent<
  PropsWithChildren<JwmAdWrapperProps>
> = ({ segmentName, children }) => {
  const segment = useFeatureFlag(
    'xf.trello-jwm-crossflow-user-segmenting',
    'not-segmented',
    {
      sendExposureEvent: true,
    },
  );

  if (segmentName === 'not-segmented') {
    return null;
  }

  if (segmentName !== segment) {
    return null;
  }

  return <>{children}</>;
};
